export default __webpack_public_path__ + "static/media/org-id.307d0a7d.svg";